// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__IV_oR","file":"styles_file__3HywQ"};